import { createFileRoute } from "@tanstack/react-router";

import ActivateEmail from "@/containers/ActivateEmail";

export const Route = createFileRoute("/activate-email/$token")({
  component: () => <ActivateEmail />,
});
